// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__fm9Q8","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2uo9K"};